import { render, staticRenderFns } from "./BannersList.vue?vue&type=template&id=24994034&scoped=true"
import script from "./BannersList.vue?vue&type=script&lang=js"
export * from "./BannersList.vue?vue&type=script&lang=js"
import style0 from "./BannersList.vue?vue&type=style&index=0&id=24994034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24994034",
  null
  
)

export default component.exports